import { Container } from '@/components/layout/Container';
import { ForresterReportQuery } from '@/graphql';
import ForresterReportQueryDocument from '@/graphql/queries/ForresterReport.gql';
import { getStaticPageProps } from '@/lib/next';
import FeatureGroupsModule from '@/modules/FeatureGroups';
import GlowQuoteModule from '@/modules/GlowQuote';
import LogoFarmModule from '@/modules/LogoFarm';
import SimpleCTAFooterModule from '@/modules/SimpleCTAFooter';
import SimpleHeroModule from '@/modules/SimpleHero';
import StatisticsBlockModule from '@/modules/StatisticsBlock';
import TextListTableModule from '@/modules/TextListTable';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { customTextSize } from '@/styles/typography/utils';
import MasterTemplate from '@/templates/MasterTemplate';
import styled from 'styled-components';

const PageWrapper = styled.section`
  overflow: hidden;

  > * {
    margin-top: 60px;
  }

  ${mediaBreakpointUp('desktop')} {
    > * {
      margin-top: 120px;
    }
  }
`;

const GlowQuote1 = styled(GlowQuoteModule)`
  --orb-left-color: ${COLORS.RED.BASE};
  --orb-right-color: ${COLORS.GREEN.BASE};
`;

const GlowQuote2 = styled(GlowQuoteModule)`
  --orb-left-color: ${COLORS.BLUE.BASE};
  --orb-right-color: ${COLORS.GREEN.BASE};
`;

const Disclaimer = styled.div`
  text-align: center;
  ${paddingY(30)}
  color: ${COLORS.GRAY.BASE};
  ${customTextSize(12, 16)}
`;

const ForresterReport: PageTemplate<ForresterReportQuery> = ({ entry }) => {
  return (
    <>
      <SimpleHeroModule props={entry?.moduleSimplehero} />
      <PageWrapper>
        <FeatureGroupsModule props={entry?.moduleFeatureGroups} />
        <TextListTableModule props={entry?.moduleTextListTable} />
        <GlowQuote1 props={entry?.moduleGlowquote} />
        <Container>
          <StatisticsBlockModule props={entry?.moduleStatisticsblock} />
        </Container>
        <GlowQuote2 props={entry?.moduleGlowquote2} />
        <Container>
          <LogoFarmModule props={entry?.moduleLogofarm} />
        </Container>
        <SimpleCTAFooterModule props={entry?.moduleSimplectafooter} />
      </PageWrapper>
      <Disclaimer>
        <Container>
          <p>This was a commissioned study conducted by Forrester Consulting on behalf of Front</p>
        </Container>
      </Disclaimer>
    </>
  );
};

ForresterReport.template = MasterTemplate;

export default ForresterReport;

export const getStaticProps = getStaticPageProps('forrester-total-economic-impact', async ({ client }) => {
  const { entry } = await client.request<ForresterReportQuery>(ForresterReportQueryDocument);

  if (!entry) return { notFound: true };

  return {
    props: {
      entry,
    },
  };
});
